export default [
  {
    path: '/racionalizacao-com',
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'Racionalização do COM Histórico',
        path: 'historico',
        component: () => import('@/views/racionalizacaoCom/Historico.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [{ name: 'Power Ups', path: '/powerups' }, { name: 'Racionalização do COM' }]
        }
      },
      {
        name: 'Racionalização do COM Adicionar',
        path: 'edit',
        component: () => import('@/views/racionalizacaoCom/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'Racionalização do COM', path: '/racionalizacao-com/historico' },
            { name: 'Adicionar' }
          ]
        }
      },
      {
        name: 'Racionalização do COM Editar',
        path: 'edit/:id',
        component: () => import('@/views/racionalizacaoCom/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'Racionalização do COM', path: '/racionalizacao-com/historico' },
            { name: 'Editar' }
          ]
        }
      }
    ]
  }
];
